// extracted by mini-css-extract-plugin
module.exports = {"formItem":"Input_formItem__1hLJY","formItemBar":"Input_formItemBar__6PVk8","label":"Input_label__2QNPk","input":"Input_input__30Csc","textarea":"Input_textarea__1U6zk"};